import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CategoryNavigationItem from './category-navigation-item';
import PointDown from '@/components/icons/point-down';
import PointUp from '@/components/icons/point-up';

function CategoryNavigation({ categories }) {
	const { t } = useTranslation();
	const [showCategories, setShowCategories] = useState(false);
	const toggleCategories = () => setShowCategories(!showCategories);

	return (
		<div className="lg:min-w-[25%] flex lg:px-8 px-4 flex-col lg:py-8 py-4 lg:border-r border-grey-330">
			<button
				type="button"
				onClick={toggleCategories}
				className={`font-bold lg:mb-2 pointer flex justify-between items-center 
        ${showCategories && 'mb-2'}`}
			>
				<span>{t('gynzy-com.categories')}</span>
				<div className="lg:hidden">{showCategories ? <PointUp /> : <PointDown />}</div>
			</button>
			<nav className={showCategories ? 'block' : 'hidden lg:block'}>
				<ul>
					{categories && categories.map(category => <CategoryNavigationItem key={category.id} category={category} />)}
				</ul>
			</nav>
		</div>
	);
}

CategoryNavigation.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	categories: PropTypes.array.isRequired,
};

export default CategoryNavigation;
